import { Capacitor, SystemBarType, SystemBars, SystemBarsStyle } from '@capacitor/core';

export const applyStatusBarStyleForDarkMode = async (darkModeEnabled: boolean): Promise<void> => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  try {
    await SystemBars.setStyle({
      bar: SystemBarType.StatusBar,
      style: darkModeEnabled ? SystemBarsStyle.Dark : SystemBarsStyle.Light,
    });
  } catch (error) {
    console.warn('Failed to apply status bar style:', error);
  }
};
